import request from 'helpers/request';
import cm from 'helpers/commons';
import api from 'config';

// 식대 그룹 조회
export const SikdaeGroupList = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/group`,
    params
  });

// 식대 정책 조회
export const SikdaePolicyList = (idx) =>
  request({
    url: `${api.config.companyAPI}/company/v1/group/${idx}/policy`,
    data: idx
  });

export const SikdaePolicyMod = (idx, params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/group/${idx}/policy`,
    method: 'put',
    data: params
  });

// 가맹점 조회
export const StoreList = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/store`,
    params
  });

// 부서 조회
export const DivisionList = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/division`
  });
// 전체 부서 조회
export const DivisionALL = () =>
  request({
    url: `${api.config.companyAPI}/company/v1/division?viewType=DEPARTMENT_TRANSFER`
  });
// 인사 및 부서 조회
export const StaffDivisionList = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/division`,
    params
  });

// 과거 부서 조회
export const PastDivisionList = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/division`,
    params
  });

// 사용자 조회
export const StaffSel = (params) => {
  let url = '/member/v1/employee';
  let requestParams = params;
  if (params && params.id) {
    url += `/${params.id}`;
    requestParams = { ...params };
    delete requestParams.id;
  }
  return request({
    url: api.config.companyAPI + url,
    params: requestParams
  });
};

// 사용자 상세 조회
export const StaffDetailSel = (userId) => {
  const url = `/member/v1/employee/${userId}`;
  return request({
    url: api.config.companyAPI + url
  });
};

// 휴면 사용자 조회
export const dormantStaff = (params) => {
  let url = '/member/v1/dormant';
  if (params && params.id) {
    url += `/${params.id}`;
  }
  return request({
    url: api.config.companyAPI + url,
    params
  });
};

// 사용자 바코드 조회
export const StaffBarcode = (params) =>
  request({
    url: `${api.config.companyAPI}/member/v1/employee/${params.userId}/barcode`
  });

// 엑셀 다운로드
export const ExcelDownload = (params) => {
  const { com } = params;
  const { excel } = params;
  const { excelResult } = params;
  const { viewType } = params;
  const apiUrl = api.config.companyAPI;

  let param = {
    filetype: 'excel',
    comid: com.id,
    requestid: com.user.id,
    viewType
  };

  if (excelResult) {
    param = cm.arrayPush(param, excelResult.excel);
  }

  return request({
    url: apiUrl + excel.url,
    method: excel.method,
    params: excel.method === 'get' ? param : null,
    data: excel.method === 'put' || excel.method === 'post' ? param : null,
    type: 'excel'
  });
};

// 권한 설정 목록
export const PresetSel = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/preset`,
    params
  });

export const StoreExcelDownload = (params) =>
  request({
    url: `${api.config.companyAPI}/company/v1/store/download`,
    params
  });

// 사용자 목록 엑셀 출력용 데이터 조회
export const GetEmployeeList = (params) =>
  request({
    method: 'get',
    url: `${api.config.companyAPI}/member/v1/excel/employees`,
    params
  });

// 식대 및 복지 그룹 엑셀 출력용 데이터 조회
export const GroupsExcelData = (params) =>
  request({
    method: 'get',
    url: `${api.config.companyAPI}/member/v1/excel/groups`,
    params
  });
